<div class="row">
    <mat-checkbox class="black" [(ngModel)]="value" (change)="valueEvent()" [ngClass]="{'checked': value,'disabled': disabled}" [disabled]="disabled">
        <span *ngIf="!isLinks" class="main_span" style="white-space: normal;">{{text}}</span>
        <div *ngIf="isLinks" class="main_span" style="white-space: normal;">
            <span style="display: inline-flex;" *ngFor="let t of textLink"><span
                    class="span" *ngIf="!t.isLink">{{t.value}}</span><span *ngIf="!t.isLink">&nbsp;</span><a *ngIf="t.isLink" href="{{t.href}}" target="_blank">{{t.value}}</a><span *ngIf="t.isLink">&nbsp;</span></span>
        </div>
    </mat-checkbox>
</div>